// Framework and third-party non-ui
import React from 'react';

// JSON & Styles
import { StyledRegisterButton } from './Register-styled';

// Third-party components (buttons, icons, etc.)

const Register = ({ ...rest }) => {

  return (
    <StyledRegisterButton data-testid="Register" onClick={(() => {window.open("https://ohid.ohio.gov/wps/portal/gov/ohid/create-account/", "_blank")})} {...rest}>
      Sign Up
    </StyledRegisterButton>
  );
};

export default Register;
